
import { Skeleton, TableRow, TableCell } from '@mui/material'

const PageListLoading = ({ headers }) => {

  const isDriverPage = window.location.pathname.includes('/drivers')

  const createWidthStyles = (width) => ({
    width: `${width}px`,
    minWidth: `${width}px`,
    maxWidth: `${width}px`,
  })

  return (
    <>
      {Array.from(Array(5).keys()).map((_, rowIndex) => (
        <TableRow key={`skeleton-loading-row-${rowIndex}`}>
          <TableCell
            sx={{
              margin: 0,
              padding: 0,
              width: 1,
              minWidth: 1,
              maxWidth: 1,
            }}/>
          {headers.map((header, cellIndex) => {

            if ((isDriverPage && header.key === 'agreementNo'))
            {return null}

            return (
              <TableCell key={`skeleton-loading-cell-${cellIndex}`} style={createWidthStyles(header.width >= 120 ? 120 : header.width)}>
                {header.key === 'checkbox' ? (
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Skeleton animation="wave" variant="circle" width={30} height={30} style={{ marginRight: 10 }} />
                    <Skeleton animation="wave" variant="circle" width={30} height={30} />
                  </div>
                ) : header.key === 'accountName' ? (
                  <Skeleton animation="wave" variant="circle" width={30} height={30} />
                ) : (
                  <Skeleton animation="wave" variant="rect" height={15} />
                )}
              </TableCell>
            )
          })}
          {!isDriverPage && (
            <TableCell
              sx={{
                minWidth: 60,
                flex: 1,
                margin: 0,
                padding: 0,
              }}/>
          )}


        </TableRow>
      ))}
    </>
  )
}

export default PageListLoading
